export const menuItems = [
  {
    name: 'Grilled Salmon',
    category: 'Main Dishes',
    description: 'Fresh Atlantic salmon grilled to perfection, served with seasonal vegetables and lemon butter sauce',
    price: '24.99',
    image: 'https://readdy.ai/api/search-image?query=grilled%20salmon%20fillet%20on%20white%20plate%20with%20fresh%20asparagus%20and%20cherry%20tomatoes%20lemon%20wedge%20garnish%20professional%20food%20photography%20simple%20clean%20white%20background%20restaurant%20quality%20plating%20natural%20lighting&width=400&height=400&seq=menu-salmon&orientation=squarish'
  },
  {
    name: 'Margherita Pizza',
    category: 'Main Dishes',
    description: 'Wood-fired pizza with San Marzano tomatoes, fresh mozzarella, basil, and extra virgin olive oil',
    price: '16.99',
    image: 'https://readdy.ai/api/search-image?query=margherita%20pizza%20with%20fresh%20basil%20and%20melted%20mozzarella%20on%20wooden%20board%20simple%20white%20background%20professional%20food%20photography%20appetizing%20presentation%20restaurant%20style&width=400&height=400&seq=menu-pizza&orientation=squarish'
  },
  {
    name: 'Caesar Salad',
    category: 'Appetizers',
    description: 'Crisp romaine lettuce, house-made Caesar dressing, parmesan cheese, and garlic croutons',
    price: '12.99',
    image: 'https://readdy.ai/api/search-image?query=fresh%20caesar%20salad%20in%20white%20bowl%20with%20parmesan%20shavings%20and%20croutons%20crisp%20romaine%20lettuce%20simple%20white%20background%20professional%20food%20photography%20healthy%20appetizing&width=400&height=400&seq=menu-salad&orientation=squarish'
  },
  {
    name: 'Chocolate Lava Cake',
    category: 'Desserts',
    description: 'Warm chocolate cake with molten center, served with vanilla ice cream and fresh berries',
    price: '9.99',
    image: 'https://readdy.ai/api/search-image?query=chocolate%20lava%20cake%20with%20molten%20center%20on%20white%20plate%20vanilla%20ice%20cream%20scoop%20fresh%20raspberries%20garnish%20simple%20white%20background%20professional%20dessert%20photography%20decadent&width=400&height=400&seq=menu-dessert&orientation=squarish'
  },
  {
    name: 'Ribeye Steak',
    category: 'Main Dishes',
    description: 'Premium 12oz ribeye steak, grilled to your preference, with roasted potatoes and herb butter',
    price: '32.99',
    image: 'https://readdy.ai/api/search-image?query=grilled%20ribeye%20steak%20on%20white%20plate%20with%20roasted%20potatoes%20and%20herbs%20professional%20food%20photography%20simple%20white%20background%20restaurant%20quality%20meat%20dish&width=400&height=400&seq=menu-steak&orientation=squarish'
  },
  {
    name: 'Fresh Lemonade',
    category: 'Drinks',
    description: 'House-made lemonade with fresh lemons, mint leaves, and a touch of honey',
    price: '4.99',
    image: 'https://readdy.ai/api/search-image?query=fresh%20lemonade%20in%20tall%20glass%20with%20ice%20cubes%20lemon%20slices%20and%20mint%20leaves%20simple%20white%20background%20professional%20beverage%20photography%20refreshing%20drink&width=400&height=400&seq=menu-drink&orientation=squarish'
  }
];